import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '@/helpers/composables/useI18n';
import { useExperiment } from '@/libraries/experiment';
import LinearOfferCTA from '@/components/experiments/LinearTVExp/LinearOfferCTA.vue';
import ListOfferPresentation from '@/features/buybox/components/list/ListOfferPresentation.vue';
import { useLinearBroadcastTime } from '@/components/experiments/LinearTVExp';
import { LinearOfferEpisode } from '@/interfaces/buybox';
import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { TitleDetail } from '@/interfaces/title-details-graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinearExtraShowings',
  props: {
    linearAdditionalEpisodes: null,
    buyboxOffer: null,
    title: null,
    seasonNumber: null,
    variant: null
  },
  emits: ["openBuyBoxInfoModal"],
  setup(__props: any) {

const { tc } = useI18n();




const showLinearEpisodes = ref(false);

const { v2Date, v2Time } = useLinearBroadcastTime();

const { trackEvent } = useExperiment('EXP_LINEAR_TV_2');

function handleShowEpisodes() {
	showLinearEpisodes.value = !showLinearEpisodes.value;

	trackEvent({
		action: 'click',
		label: showLinearEpisodes.value ? 'see_more_expand' : 'see_more_collapse',
	});
}

return { __sfc: true,tc, showLinearEpisodes, v2Date, v2Time, trackEvent, handleShowEpisodes, faChevronDown, faChevronUp, LinearOfferCTA, ListOfferPresentation }
}

})